export default function StudentIcon() {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.99999 6.8C7.65749 6.8 8.99999 5.4575 8.99999 3.8C8.99999 2.1425 7.65749 0.799999 5.99999 0.799999C4.34249 0.799999 2.99999 2.1425 2.99999 3.8C2.99999 5.4575 4.34249 6.8 5.99999 6.8ZM5.25749 8.2C2.79499 8.2 0.799988 10.195 0.799988 12.6575C0.799988 13.0675 1.13249 13.4 1.54249 13.4H10.4575C10.8675 13.4 11.2 13.0675 11.2 12.6575C11.2 10.195 9.20499 8.2 6.74249 8.2H5.25749Z" fill="currentColor"/>
        </svg>
    );
}